import { render } from "./TrainingLinksView.vue?vue&type=template&id=0b30ab7c"
import script from "./TrainingLinksView.vue?vue&type=script&lang=js"
export * from "./TrainingLinksView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__